export default "__VITE_ASSET__B9CPRfEV__"